// interactionEventQueue.js
// Simpler than sectionEventQueue.js since clicks are instantaneous and hover duration
// is already computed before the event is pushed - no open/close pairing needed here.

import { clientApi } from "./clientApi";

let queue = [];

export function enqueueInteraction(event) {
  queue.push(event);
}

export async function flushInteractionEvents() {
  if (queue.length === 0) return;

  const batch = queue;
  queue = []; // clear immediately so events arriving during the request aren't dropped or duplicated

  try {
    await clientApi.sendInteractionEvents(batch);
  } catch {
    // Analytics data, not critical - if the flush fails we simply lose that batch.
  }
}